import React from 'react'
import { getLogoVariant } from '../utils/brandUtils'

interface ProfessionalLoadingProps {
  message?: string
  size?: 'small' | 'medium' | 'large'
  variant?: 'spinner' | 'pulse' | 'progress'
  showLogo?: boolean
  className?: string
}

export const ProfessionalLoading: React.FC<ProfessionalLoadingProps> = ({
  message = 'Loading...',
  size = 'medium',
  variant = 'spinner',
  showLogo = false,
  className = ''
}) => {
  const sizeClasses = {
    small: 'professional-loading--small',
    medium: 'professional-loading--medium',
    large: 'professional-loading--large'
  }

  const variantClasses = {
    spinner: 'professional-loading--spinner',
    pulse: 'professional-loading--pulse',
    progress: 'professional-loading--progress'
  }

  return (
    <div className={`professional-loading ${sizeClasses[size]} ${variantClasses[variant]} ${className}`}>
      {showLogo && (
        <div className="professional-loading__logo">
          <img 
            src={getLogoVariant('loading').src}
            alt={getLogoVariant('loading').alt}
            className="professional-loading__logo-image professional-logo--loading"
            style={{ display: 'block', margin: '0 auto' }}
          />
        </div>
      )}
      
      {variant === 'spinner' && (
        <div className="professional-loading__spinner">
          <div className="professional-loading__spinner-circle"></div>
        </div>
      )}
      
      {variant === 'pulse' && (
        <div className="professional-loading__pulse">
          <div className="professional-loading__pulse-dot"></div>
          <div className="professional-loading__pulse-dot"></div>
          <div className="professional-loading__pulse-dot"></div>
        </div>
      )}
      
      {variant === 'progress' && (
        <div className="professional-loading__progress">
          <div className="professional-loading__progress-bar">
            <div className="professional-loading__progress-fill"></div>
          </div>
        </div>
      )}
      
      {message && (
        <div className="professional-loading__message">
          {message}
        </div>
      )}
    </div>
  )
}